/**
 * @generated SignedSource<<cd16de75d4eb99ba5e92c1dbf36f70db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BountyStatus = "ACTIVE" | "ACTIVE_BUT_BONUS_EXISTS" | "CLAIMED" | "FINISHED" | "PAUSED" | "RE_CLAIMABLE" | "%future added value";
export type BountiesContextQuery$variables = {
  code?: string | null;
};
export type BountiesContextQuery$data = {
  readonly listBounties: ReadonlyArray<{
    readonly bountyId: number;
    readonly amount: number;
    readonly currency: string;
    readonly title: string;
    readonly subtitle: string;
    readonly extendedInfo: string;
    readonly bgImageUrl: string | null;
    readonly rating: number;
    readonly status: BountyStatus;
    readonly expires: string | null;
    readonly claimCount: number;
    readonly claimLimit: number;
  }>;
};
export type BountiesContextQuery = {
  variables: BountiesContextQuery$variables;
  response: BountiesContextQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      }
    ],
    "concreteType": "Bounty",
    "kind": "LinkedField",
    "name": "listBounties",
    "plural": true,
    "selections": [
      {
        "alias": "bountyId",
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subtitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "extendedInfo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bgImageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expires",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claimCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claimLimit",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BountiesContextQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BountiesContextQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ea0004b8bb15f98ec1e656ac9d26585c",
    "id": null,
    "metadata": {},
    "name": "BountiesContextQuery",
    "operationKind": "query",
    "text": "query BountiesContextQuery(\n  $code: String\n) {\n  listBounties(code: $code) {\n    bountyId: id\n    amount\n    currency\n    title\n    subtitle\n    extendedInfo\n    bgImageUrl\n    rating\n    status\n    expires\n    claimCount\n    claimLimit\n  }\n}\n"
  }
};
})();

(node as any).hash = "d5f4896169531f5a02b83cabff6553f1";

export default node;
